import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/tiposDeEquipamentosVeiculo/actions';

import Form from './form';

function TiposDeEquipamentosVeiculo() {
  const redux = useSelector((state) => state.tiposDeEquipamentosVeiculo);

  const header = useMemo(() => [{
    id: 'nometipolocomotiva',
    label: t('s.configuracao.posto.nomeposto'),
    filter: { type: 'text' },
  },], []);

  const fieldlist = [
    'nometipolocomotiva',
  ];

  const substituirHeader = {
    nometipolocomotiva:
      t('s.configuracao.posto.nomeposto'),
  };

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findData}
        remove={deleteData}
        form={Form}
        keys="idtipolocomotiva"
        detach="nometipolocomotiva"
        pdf
        excel
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'tipolocomotiva',
            formato,
            fields: fieldlist,
            headers: substituirHeader,
            redux,
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            title: t('s.menu.cadastro.tiposdeequipamentosveiculo'),
          })
        }
      />
    </>
  );
}

export default TiposDeEquipamentosVeiculo;
